import objectLabsMarkUrl from '../assets/object-labs-mark.png';
import { cn } from '../lib/cn';

const OBJECT_LABS_RATIO = 389 / 80;

export interface ObjectLabsMarkProps {
  height?: number;
  className?: string;
}

/**
 * The Object Labs wordmark, for the **super admin footer only** ("operated by").
 * It is not a HeyAllergy asset and must not appear in the clinic admin or the patient
 * app, where the tenant's own branding is the only branding a user should see.
 */
export function ObjectLabsMark({ height = 18, className }: ObjectLabsMarkProps) {
  return (
    <img
      src={objectLabsMarkUrl}
      alt="Object Labs"
      width={Math.round(height * OBJECT_LABS_RATIO)}
      height={height}
      style={{ height }}
      className={cn('block w-auto', className)}
      data-testid="object-labs-mark"
    />
  );
}
